<template>
	<modal ref="modal">
		<template #title>{{action.toUpperCase()}} COUPON CONTENT</template>
		<template #body>
			<div v-if="action=='update'" class="form-control mb-4 fw-bold text-center border-danger">
				<label class="me-1">COUPON:</label><span>{{form.coupon_code}}</span>
			</div>
			<div v-if="action=='add'" class="form-check form-check-inline">
				<input
					@change="isCustomCoupon()"
					v-model="form.is_custom_coupon"
					id="is_custom_coupon"
					name="is_custom_coupon"
					class="form-check-input"
					type="checkbox"
				/>
				<label class="form-check-label bg-alt-primary fw-bold" for="is_custom_coupon">Is Custom Coupon?</label>
			</div>
			<div class="form-floating mb-4">
				<select v-model="form.membership" id="membership" name="membership" class="form-control">
                  <option value="ALL">ALL</option>
                  <option value="TRC COUPLE">TRC COUPLE</option>
                  <option value="BCC">BCC</option>
                  <option value="SILVER">SILVER</option>
                  <option value="GOLD">GOLD</option>
                  <option value="DIAMOND">DIAMOND</option>
                  <option value="PLATINUM">PLATINUM</option>
                  <option value="PLATINUM COUPLE">PLATINUM COUPLE</option>
                </select>
				<label class="form-label" for="membership">Category</label>
			</div>
			<div class="form-floating mb-4">
				<select v-model="form.applicable_months" id="applicable_months" name="applicable_months" class="form-control" placeholder="Applicable Months">
                  <option value="ALL">ALL</option>
                  <option value="1">1 Month</option>
                  <option value="3">3 Months</option>
                  <option value="6">6 Months</option>
                  <option value="12">12 Months</option>
                  <option value="24">24 Months</option>
                </select>
				<label class="form-label" for="applicable_months">Applicable Months</label>
			</div>
			<div class="form-floating mb-4">
				<select v-model="form.coupon_type" id="coupon_type" name="coupon_type" class="form-control" placeholder="Coupon Type">
                  <option value="percent">Percent</option>
                  <option value="amount">Amount</option>
                </select>
				<label class="form-label" for="coupon_type">Type</label>
			</div>
			<div v-if="action=='add' && form.is_custom_coupon==false" class="row">
				<div class="col-6">
					<div class="form-floating mb-4">
						<input v-model="form.prefix_code" type="text" id="prefix_code" name="prefix_code" class="form-control" placeholder="Prefix" />
						<label class="form-label" for="prefix_code">Prefix</label>
					</div>
				</div>
				<div class="col-6">
					<div class="form-floating mb-4">
						<input v-model="form.suffix_code" type="text" id="suffix_code" name="suffix_code" class="form-control" placeholder="Suffix" />
						<label class="form-label" for="suffix_code">Suffix</label>
					</div>
				</div>
			</div>
			<div v-if="action=='add' && form.is_custom_coupon==false" class="form-floating mb-4">
				<input v-model="form.code_length" type="number" id="code_length" name="code_length" min="5" class="form-control" placeholder="Code Length" />
				<label class="form-label" for="code_length">Code Length</label>
			</div>
			<div v-if="action=='add' && form.is_custom_coupon==true" class="form-floating mb-4">
				<input v-model="form.custom_coupon_code" type="text" id="custom_coupon_code" name="custom_coupon_code" class="form-control" placeholder="Custom Coupon Code" />
				<label class="form-label" for="custom_coupon_code">Coupon Code</label>
				<div v-if="form.errors.custom_coupon_code" class="text-danger">{{form.errors.custom_coupon_code}}</div>
			</div>
			<div class="form-floating mb-4">
				<input v-model="form.amount" type="number" id="amount" name="amount" min="5" class="form-control"  placeholder="Amount"/>
				<label class="form-label" for="amount">Amount</label>
			</div>
			<div class="form-floating mb-4">
				<input v-model="form.expiry_date" type="date" id="expiry_date" name="expiry_date" class="form-control" placeholder="Expiry Date"/>
				<label class="form-label" for="expiry_date">Expiry Date</label>
			</div>
			<div class="form-floating mb-4">
				<input v-model="form.expiry_time" type="time" id="expiry_time" name="expiry_time" class="form-control" placeholder="Expiry Time"/>
				<label class="form-label" for="expiry_time">Expiry Time</label>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="status">Reusable?</label>
				<div class="mt-2">
					<div class="form-check form-check-inline">
						<input
							v-model="form.is_reuse"
							id="is_reuse_on"
							name="is_reuse"
							class="form-check-input"
							type="radio"
							value="1"
						/>
						<label class="form-check-label bg-alt-primary" for="YES">YES</label>
					</div>
					<div class="form-check form-check-inline">
						<input
							v-model="form.is_reuse"
							id="is_reuse_off"
							name="is_reuse"
							class="form-check-input"
							type="radio"
							value="0"
						/>
						<label class="form-check-label bg-alt-primary" for="NO">NO</label>
					</div>
				</div>
			</div>
			<div v-if="form.is_reuse==1" class="form-floating mb-4">
				<input v-model="form.limit_use" type="number" id="limit_use" name="limit_use" class="form-control" placeholder="Limit Use"/>
				<label class="form-label" for="limit_use">Limit Use</label>
			</div>
			<div v-if="action=='add'" class="form-floating mb-4">
				<input v-model="form.total_generate" :disabled="form.is_custom_coupon==true" type="number" id="total_generate" name="total_generate" class="form-control" placeholder="Number of Coupon to Generate">
				<label class="form-label" for="total_generate">Number of Coupon to Generate</label>
			</div>
			
			<div v-if="action=='update'" class="form-floating mb-4">
				<select v-model="form.status" id="status" name="status" class="form-control" placeholder="Coupon Status">
                  <option value="Used">Used</option>
                  <option value="Not Used">Not Used</option>
                </select>
				<label class="form-label" for="status">Status</label>
			</div>

			<div class="form-floating mb-4">
				<input v-model="form.c_source" type="text" id="c_source" name="c_source" class="form-control" placeholder="Source" />
				<label class="form-label" for="c_source">Source</label>
			</div>

		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Generate</span><span v-else>Update</span> Coupon</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	props: {
		filter : String,
		errors: Object
	},
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}
		
		const action = ref('add');

		const form = useForm({
			membership 			: 'ALL',
			applicable_months	: 'ALL',
			coupon_type 		: 'amount',
			prefix_code 		: '',
			suffix_code 		: '',
			code_length 		: 5,
			coupon_code 		: null,
			is_custom_coupon 	: false,
			custom_coupon_code 	: null,
			amount 				: 0,
			limit_use 			: 1,
			is_reuse 			: 0,
			expiry_date 		: null,
			expiry_time 		: null,
			total_generate 		: 1,
			status 				: 'Not Used',
			c_source 			: null,
		})

		const isCustomCoupon = ()=>{
			if(form.is_custom_coupon==true)
			{
				form.total_generate = 1;
			}else
			{
				form.custom_coupon_code = '';	
				form.code_length = 5;
			}
		}

		const actionContent = ()=>{

			if(action.value=='add')
			{
				generateCoupons();
			}else
			{
				updateContent();	
			}

		}

		const generateCoupons = () => {
			form.post(route('admin.post.coupons-generate'), {
				preserveState: true,
				preserveScroll: true,
				only:['coupons,api_response','filter','errors'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const updateContent = () => {
			form.put('coupon/'+form.coupon_uuid, {
				preserveState: true,
				preserveScroll: true,
				only:['coupons,api_response','filter','errors'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const setCouponContent = (_action,data)=>{
								
								form.reset();

								action.value = _action;

								if(_action=='update')
								{
									form.coupon_uuid 		= data.coupon_uuid;
									form.membership 		= data.membership;
									form.applicable_months 	= data.applicable_months;
									form.prefix_code 		= data.prefix_code;
									form.suffix_code 		= data.suffix_code;
									form.coupon_code 		= data.coupon_code;
									form.coupon_type 		= data.coupon_type;
									form.amount 			= data.amount;
									form.expiry_date 		= data.expiry_date;
									form.expiry_time 		= data.expiry_time;
									form.limit_use 			= data.limit_use;
									form.is_reuse 			= data.is_reuse;
									form.c_source 			= data.c_source;
								}
								
							}


		return {
			form,
			modal,
			toggleModal,
			action,
			isCustomCoupon,
			setCouponContent,
			actionContent,
			generateCoupons,
			updateContent,
		}
	},
}
</script>
